import { gql } from '@apollo/client';

// Build the GraphQL query to get username (PostGraphile version)
export const GET_NAME_QUERY = gql`
  query GetName($id: String!) {
    identityByAccountId(accountId: $id) {
      accountId
      name
    }
  }
`;

export interface Identity {
  accountId: string;
  name: string | null;
}

export interface GetNameResponse {
  identityByAccountId: Identity | null;
}

// Legacy type aliases for backward compatibility
export type AccountById = Identity;
export type AccountByPk = Identity;
